const URLS = {
    HOME: '/',
    ABOUT: '/o-nas',
    WORK: '/jak-pracujemy',
    COURSE: '/kurs',
    COUPLES: '/realizacje',
    COUPLES_EVENT: '/realizacje/:path',
    OFFER: '/oferta',
    BLOG: '/blog-1',
    BLOG_PAGE: '/blog-1/page/:page',
    CATEGORY: '/blog-1/categories/:tag',
    CATEGORY_PAGE: '/blog-1/categories/:tag/page/:page',
    POST: '/post/:path',
    CONTACT: '/kontakt',
    LANDING: '/:path'
}

export default URLS